import { formatDistanceToNow } from 'date-fns';
import React from 'react';
import { Avatar } from '~/components/Avatar';
import LockerLink from '~/components/Links/LockerLink';
import {
  NegativeFeedbackIcon,
  NeutralFeedbackIcon,
  PositiveFeedbackIcon,
} from '~/public/static/svg/FeedbackIcons';
import { RailsUserFeedback } from '~/typings/services/rails/user';

interface Props {
  feedbackData: RailsUserFeedback[];
  showRatingType?: boolean;
}

const LockerFeedbackList: React.FC<Props> = ({
  feedbackData,
  showRatingType,
}) => {
  if (feedbackData.length === 0) {
    return <div className="text-center text-xl font-semibold">No feedback</div>;
  }

  return (
    <div className="divide-y">
      {feedbackData.map(feedback => (
        <div key={feedback.id} className="flex space-x-2 py-2">
          <LockerLink username={feedback.reviewer.username}>
            <Avatar
              avatarUrl={feedback.reviewer.avatar_url}
              alt={feedback.reviewer.username}
            />
          </LockerLink>

          <div className="flex-1">
            <div className="mb-1 flex items-center space-x-1">
              {showRatingType &&
                (feedback.rating === 'positive' ? (
                  <PositiveFeedbackIcon />
                ) : feedback.rating === 'negative' ? (
                  <NegativeFeedbackIcon />
                ) : feedback.rating === 'neutral' ? (
                  <NeutralFeedbackIcon />
                ) : null)}
              <LockerLink
                className="text-sm font-semibold"
                username={feedback.reviewer.username}
              >
                {feedback.reviewer.username}
              </LockerLink>
            </div>

            <div className="text-sm">{feedback.body}</div>
          </div>

          <div
            className="text-2xs text-slate-green-500 font-semibold"
            title={new Date(feedback.created_at).toLocaleString()}
          >
            {formatDistanceToNow(new Date(feedback.created_at), {
              addSuffix: true,
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LockerFeedbackList;
